import axios from 'axios'

export const setApplication = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_SERVER}/application`,
      data,
    )
    return res?.data
  } catch (error) {
    return { error }
  }
}

export const login = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_SERVER}auth/login`,
      data,
    )
    return res?.data
  } catch (error) {
    console.log(error)
  }
}

export const makeState = async (state, id) => {
  const res = await axios.patch(
    `${process.env.REACT_APP_SERVER}command/state/${id}`,
    { state },
  )
  return res?.data
}

export const send_demand = async (service) => {
  try {
    const res = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_SERVER}command/create`,
      data: service,
      headers: {
        'access-token': localStorage.getItem('token'),
      },
    })
    return res.data
  } catch (error) {
    console.log(error.response.data)
    return error.response.data
  }
}

export const passwordChange = async (pass) => {
  try {
    const res = await axios({
      method: 'patch',
      url: `${process.env.REACT_APP_SERVER}auth/password`,
      data: pass,
      headers: {
        'access-token': localStorage.getItem('token'),
      },
    }).catch((err) => {
      return err.response
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const removeS = async (id) => {
  const token = localStorage.getItem('token') || null
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_SERVER}command/${id}`,
      { headers: { 'x-access-token': token } },
    )
    return res.data
  } catch (error) {
    console.log(error)
  }
}

export const toConfirm = async (id) => {
  const token = localStorage.getItem('token') || null
  try {
    console.log(token)
    const res = await axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_SERVER}candidacy/accept/${id}`,
      headers: { 'x-access-token': token },
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const getFriend = async () => {
  const token = localStorage.getItem('token') || null
  try {
    const res = await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_SERVER}user/friend/get`,
      headers: { 'x-access-token': token },
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const getFriendMatch = async ({town,district}) => {
  const token = localStorage.getItem('token') || null
  try {
    const res = await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_SERVER}user/friend/match/${town}/${district}`,
      headers: { 'x-access-token': token },
    })
    console.log(res);
    return res.data
  } catch (error) {
    console.log(error)
  }
}


export const cancelCandidacy = async (id) => {
  const token = localStorage.getItem('token') || null
  try {
    const res = await axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_SERVER}candidacy/cancel/${id}`,
      headers: { 'x-access-token': token },
    })
    console.log(res);
    return res;
  } catch (error) {
    console.log(error)
  }
}


export const removeCandidacy = async (id) => {
  const token = localStorage.getItem('token') || null
  try {
    const res = await axios({
      method: 'DELETE',
      url: `${process.env.REACT_APP_SERVER}candidacy/remove/${id}`,
      headers: { 'x-access-token': token },
    })
    console.log(res);
    return res;
  } catch (error) {
    console.log(error)
  }
}